import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetAgentsQueryParams {}

export const getAgents = async (
  props: QueryProps<GetAgentsQueryParams>
): Promise<NewUser[]> => {
  const res = await api.client.get("/agents-new", {
    signal: props.signal,
  });
  return res.data;
};
